import React from 'react';
import PropTypes from 'prop-types';

const ContractBlock = ({ children }) => {
  return (
    <>
      {children ? (
        <div className="border border-gray-400 p-4 rounded-md max-h-80 overflow-scroll">
          {children}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

ContractBlock.propTypes = {
  children: PropTypes.node,
};

export default ContractBlock;
